import { Component, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { RouterOutlet } from '@angular/router';
import { NgClass, NgIf } from '@angular/common';
import { AuthenticationService } from '../../_services/authentication.service';

@Component({
  selector: 'app-main',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, SidebarComponent, RouterOutlet, NgClass,NgIf],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent {
  transparent = false;
  heading = '';
  toggle_sidebar = false;

  constructor(private cdref: ChangeDetectorRef,public authService: AuthenticationService){ }

  ngAfterViewInit() {
    this.cdref.detectChanges();
  }

  receiveHeading(event: string){
    this.heading = event;
    this.cdref.detectChanges();
  }

  receiveSidebarEvent(event: boolean){
    this.toggle_sidebar = event;
    this.cdref.detectChanges();
  }
}
